"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Party = void 0;
var vue_1 = require("vue");
exports.Party = vue_1.default.component('party', {
    props: {
        party: {
            type: Object,
        },
        isDominant: {
            type: Boolean,
        },
        isAvailable: {
            type: Boolean,
        },
    },
    methods: {
        partyNameToCss: function (party) {
            if (party === undefined) {
                console.warn('no party provided');
                return '';
            }
            return party.toLowerCase().split(' ').join('_');
        },
        getDominantClass: function () {
            return 'select-party-leader-spot' + (this.isDominant ? ' dominance-marker' : '');
        },
        getUnavailablePartyClass: function () {
            return this.isAvailable ? '' : ' unavailable-party';
        },
    },
    template: "\n    <div :class=\"'filterDiv party-container party-background--' + partyNameToCss(party.name) + getUnavailablePartyClass()\">\n      <div :class=\"'board-party board-party--' + partyNameToCss(party.name)\">\n        <div :class=\"getDominantClass()\">\n          <div class=\"send-delegate-leader-spot\">\n            <div v-if=\"party.partyLeader\" :class=\"['player-token', party.partyLeader]\"></div>\n          </div>\n        </div>\n        <div class=\"grid-delegates grid-in-send-delegate\">\n          <div class=\"delegate-spot\" v-for=\"n in 6\" :key=\"n\">\n            <div v-if=\"party.delegates.length >= n\" :class=\"'player-token '+party.delegates[n-1].color\">\n              <div class=\"count-in-send-delegate\">{{ party.delegates[n-1].number }}</div>\n            </div>\n          </div>\n        </div>\n        <div :class=\"'selectable-party-name party-name party-name--'+partyNameToCss(party.name)\" v-i18n>{{party.name}}</div>\n      </div>\n    </div>\n    ",
});
//# sourceMappingURL=Party.js.map